var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SignIn page center-col"},[_c('Spinner',{staticClass:"stretch"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }